



















































import { Vue, Prop, Component } from 'vue-property-decorator';
import NumberInput from '@/components/common/NumberInput.vue';

type DeliveryFeeRange = {
  aboveOrEqual: string;
  below: string | null;
  deliveryAmt: string;
};

const parseNumberSafely = (value: string) => {
  const parsed = Number(value);
  return isNaN(parsed) ? 0 : parsed;
};

const MINIMUM = 0.01;

@Component({ components: { NumberInput } })
export default class WeightFee extends Vue {
  @Prop() private deliveryFeeRanges?: DeliveryFeeRange[];
  @Prop({ default: 'KRW' }) private currencyCode!: string;

  private addItem(idx: number) {
    const slicedPrevArray = this.deliveryFeeRanges.slice(0, idx + 1);
    const slicedNextArray = this.deliveryFeeRanges.slice(idx + 1).map((deliveryFeeRange, internalIdx) => ({
      // 첫요소의 aboveOrEqual은 이전구간으로 이동하여 빈값으로 노출
      aboveOrEqual: internalIdx ? deliveryFeeRange.aboveOrEqual : '',
      below: deliveryFeeRange.below,
      deliveryAmt: deliveryFeeRange.deliveryAmt,
    }));

    if (
      parseNumberSafely(slicedNextArray?.at(0)?.below ?? '') ===
      parseNumberSafely(slicedPrevArray?.at(-1)?.below ?? '') + MINIMUM
    ) {
      alert('최소 단위는 0.01입니다.');
      return;
    }

    this.$emit('update:deliveryFeeRanges', [
      ...slicedPrevArray,
      { aboveOrEqual: slicedPrevArray?.at(-1)?.below ?? '', below: '', deliveryAmt: '' },
      ...slicedNextArray,
    ]);
  }

  private removeItem(idx: number) {
    const slicedPrevArray = this.deliveryFeeRanges.slice(0, idx);
    const slicedNextArray = this.deliveryFeeRanges.slice(idx + 1).map((deliveryFeeRange, internalIdx) => ({
      // 마지막 요소의 aboveOrEqual은 이전구간으로 이동하여 빈값으로 노출
      aboveOrEqual: internalIdx ? deliveryFeeRange.aboveOrEqual : slicedPrevArray?.at(-1)?.below ?? '',
      below: deliveryFeeRange.below,
      deliveryAmt: deliveryFeeRange.deliveryAmt,
    }));

    this.$emit('update:deliveryFeeRanges', [...slicedPrevArray, ...slicedNextArray]);
  }

  private onBlur(value: string, idx: number) {
    const lastSlicedElement =
      this.deliveryFeeRanges
        .slice(0, idx + 1)
        ?.filter(item => Boolean(item.aboveOrEqual))
        ?.at(-1)?.aboveOrEqual ?? '';

    let deliveryFeeRanges: DeliveryFeeRange[];

    if (!!value.trim() && parseNumberSafely(lastSlicedElement) >= parseNumberSafely(value ?? '')) {
      alert('최소중량보다 큰 중량을 입력해주세요.');

      deliveryFeeRanges = this.deliveryFeeRanges?.map((deliveryFeeRange, internalIdx) => {
        if (internalIdx === idx) {
          deliveryFeeRange.below = '';
        }
        if (internalIdx === idx + 1) {
          deliveryFeeRange.aboveOrEqual = '';
        }
        return deliveryFeeRange;
      });
    } else {
      deliveryFeeRanges = this.deliveryFeeRanges?.map((deliveryFeeRange, internalIdx) => {
        if (internalIdx === idx + 1) {
          deliveryFeeRange.aboveOrEqual = value ?? '';
        }
        return deliveryFeeRange;
      });
    }

    this.$emit('update:deliveryFeeRanges', deliveryFeeRanges);
  }

  private validateOnBlur(value?: string): boolean {
    if(this.currencyCode === 'KRW' && Number(value ?? 0) % 10){
      alert('10원 단위로 입력해주세요.');

      return false;
    } 
    return true
  }

  created() {
    if (!this.deliveryFeeRanges || !this.deliveryFeeRanges?.length) {
      this.$emit('update:deliveryFeeRanges', [
        {
          aboveOrEqual: '0.01',
          below: '',
          deliveryAmt: '',
        },
        {
          aboveOrEqual: '',
          below: undefined,
          deliveryAmt: '',
        },
      ]);
    }
  }
}
